"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deriveOpcodeTable = deriveOpcodeTable;
exports.generateSeedOpcodeMapping = generateSeedOpcodeMapping;
const VMConstants_1 = require("../constants/VMConstants");
const D_MULT1 = 2246822507;
const D_MULT2 = 3266489909;
const D_SHIFT1 = 0x10;
const D_SHIFT2 = 0x0D;
const D_SHIFT3 = 0x10;
const D_PHI = 2654435769;
function mixBits(h) {
    h = h >>> 0;
    h ^= h >>> D_SHIFT1;
    h = Math.imul(h, D_MULT1) >>> 0;
    h ^= h >>> D_SHIFT2;
    h = Math.imul(h, D_MULT2) >>> 0;
    h ^= h >>> D_SHIFT3;
    return h >>> 0;
}
function deriveValue(seed, index) {
    let combined = (seed ^ (index * D_PHI)) >>> 0;
    combined = (combined ^ (combined >>> 11)) >>> 0;
    combined = Math.imul(combined, 461845907) >>> 0;
    combined = (combined ^ (combined >>> 15)) >>> 0;
    return mixBits(combined);
}
function deriveOpcodeTable(seed, instrCount, constCount) {
    let mixedSeed = seed ^ ((instrCount * D_PHI) >>> 0);
    mixedSeed = (mixedSeed ^ ((constCount * 668265261) >>> 0)) >>> 0;
    mixedSeed = mixBits(mixedSeed);
    const arr = [];
    for (let i = 0; i < VMConstants_1.VM_OPCODE_COUNT; i++) {
        arr[i] = i;
    }
    for (let i = VMConstants_1.VM_OPCODE_COUNT - 1; i > 0; i--) {
        const randVal = deriveValue(mixedSeed, i);
        const j = randVal % (i + 1);
        const tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
    }
    const opMap = {};
    for (let i = 0; i < VMConstants_1.VM_OPCODE_COUNT; i++) {
        opMap[i] = arr[i];
    }
    return opMap;
}
function generateSeedOpcodeMapping(randomIntFn, instrCount, constCount) {
    const seed = randomIntFn();
    const opcodeMap = deriveOpcodeTable(seed, instrCount, constCount);
    return { seed, opcodeMap };
}
